// test1983
(1983 && 0);
